import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, ElementRef, OnInit, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SidebarService } from '../shared/components/sidebar/sidebar.service';
import { CaseService } from '../shared/services/case.service';
import { LettersService } from '../shared/services/letters.service';
import { FileUploaderComponent } from './shared/file-uploader/file-uploader.component';
import { TimelineItemComponent } from './timeline-item/timeline-item.component';
import { Subscription } from 'rxjs';
import { MatMenuTrigger } from '@angular/material/menu';
import { CaseFilesService } from '../shared/services/casefiles.service';
import { CorrespondenceTimelineService } from '../shared/services/correspondence-timeline.service';
import { PdfCreatorComponent } from '../case/shared/pdf-creator/pdf-creator.component';
import { RenameItemComponent } from './../shared/components/rename-item/rename-item.component';
import { EmailComponent } from './shared/email/email.component';
import { PhonecallComponent } from './shared/phonecall/phonecall.component';
import { SmsComponent } from './shared/sms/sms.component';
import { FaxComponent } from './shared/fax/fax.component';
import { faEllipsisH, faThumbtack, faSearch, faBackspace, faCheckSquare, faTimes, faPause, faPlay,faHistory,faEllipsis, faArrowToLeft } from '@fortawesome/pro-light-svg-icons';
import { environment } from '../../../src/environments/environment';
import { ViewCaseNoteComponent } from './shared/case-notes/view-case-note/view-case-note.component';
import { OnHoldComponent } from '../on-hold/on-hold.component';
import { OffHoldComponent } from '../off-hold/off-hold.component';
import { ArchiveTimelineItemComponent } from './shared/archiving-items/archive-timeline-item/archive-timeline-item.component';
import { AuthService } from '../auth/auth.service';
import { ArchivedTimelineItemListComponent } from './shared/archiving-items/archived-timeline-item-list/archived-timeline-item-list.component';
import { DocumentPreviewComponent } from './shared/document-preview/document-preview.component';
import { KlyantService } from '../shared/services/klyant.service';
import { KlyantComponent } from '../klyant/klyant.component';
import { ItemPdfGeneratorComponent } from './shared/item-pdf-generator/item-pdf-generator.component';
import { CaseSidebarComponent } from './shared/case-sidebar/case-sidebar.component';
import { ModalService } from '../shared/services/modal.service';
import { OkPopupComponent } from '../shared/components/ok-popup/ok-popup.component';

@Component({
  selector: 'app-case',
  templateUrl: './case.component.html',
  styleUrls: ['./case.component.scss']
})
export class CaseComponent implements OnInit {

  @ViewChild(CaseSidebarComponent) sideBar:CaseSidebarComponent;

  showDrop = false;
  showSidebar = false;
  isMedium = false;
  isSmall = false;
  allowMultiSelect: boolean = false;
  caseId?: number;
  klyantEnabled: boolean = false;
  klyantDetails: any = [];
  case: any;
  caseLoaded: boolean = false;
  timelineItemsLoading: boolean = false;

  searchType: any [] = [];
  searchString: string = '';
  showSearch: boolean = false;

  caseReference: string = "";

  correspondenceTimelineItems: any[] = [];
  archivedCorrespondenceTimelineItems: any[] = [];

  selectedItems: any[] = [];
  existingFiles: any[] = [];
  faEllipsisH = faEllipsisH;
  faThumbtack = faThumbtack;
  faSearch= faSearch;
  faBackspace = faBackspace;
  faCheckSquare = faCheckSquare;
  faTimes = faTimes;
  faPause = faPause;
  faPlay = faPlay;
  faHistory = faHistory;
  faEllipsis = faEllipsis;
  faArrowToLeft = faArrowToLeft;

  showCaseHeader: boolean = false;
  caseHeaderMessage: string = '';
  caseHeaderAlert: boolean = false;
  caseHeaderWarning: boolean = false;
  caseHeaderInfo: boolean = false;
  caseHeaderColour: string = '';

  caseInfoOpen: boolean = true;

  caseCompleted: boolean = false;

  @ViewChild('innerContent') innerContent: ElementRef | undefined;
  @ViewChildren(TimelineItemComponent) timelineItems!: QueryList<TimelineItemComponent>;

  @ViewChild('contextMenuTrigger') contextMenuTrigger!: MatMenuTrigger;

  @ViewChild(MatMenuTrigger)  contextMenu!: MatMenuTrigger;
  contextMenuPosition = { x: '0px', y: '0px' };

  @ViewChild(MatMenuTrigger)  contextMenuMultipleSelected!: MatMenuTrigger;

  refreshSubscription: Subscription;
  refreshTimelineSubscription: Subscription;

  selectedItem: any;

  typeOptions = [
    { value: '1', label: 'Email', class: 'email' },
    { value: '2', label: 'Letter', class: 'letter' },
    { value: '3', label: 'Case File', class: 'casefile' },
    { value: '4', label: 'Phonecall', class: 'phonecall' },
    { value: '5', label: 'Text Message', class: 'textmessage' },
    { value: '6', label: 'Fax', class: 'fax' },
    { value: '8', label: 'Note', class: 'note' },
    { value: '9', label: 'Key Date', class: 'keydate' },
    { value: '10', label: 'On Hold', class: 'onhold' },
    { value: '11', label: 'Off Hold', class: 'offhold' },
  ];

  constructor(private renderer: Renderer2,
    breakpointObserver: BreakpointObserver,
    sidebarService: SidebarService,
    private caseService: CaseService,
    activatedRoute: ActivatedRoute,
    private caseFilesService: CaseFilesService,
    private lettersService: LettersService,
    private correspondenceTimelineService: CorrespondenceTimelineService,
    private router: Router,
    public authService: AuthService,
    private klyantService: KlyantService,
    private modalService: ModalService) {

    const layoutChanges = breakpointObserver.observe([Breakpoints.Medium, Breakpoints.Small, Breakpoints.XSmall]);

    layoutChanges.subscribe(result => {

      this.isSmall = breakpointObserver.isMatched([Breakpoints.Small, Breakpoints.XSmall]);
      this.isMedium = breakpointObserver.isMatched([Breakpoints.Medium, Breakpoints.Small, Breakpoints.XSmall]);

      if (this.isSmall) {
        sidebarService.closeSideBar();
      }
    });

    sidebarService.showSideBarObservable.subscribe(result => {
      this.showSidebar = result;
    });

    activatedRoute.params.subscribe(params => {
      //this.allLoaded = false;
      //this.caseLoaded = false;
      this.caseId = +params['id'];
      this.getCase();
      this.loadCorrespondenceItems();
    });

    this.refreshTimelineSubscription = this.correspondenceTimelineService.refreshCaseTimelineObservable.subscribe(() => {
      this.loadCorrespondenceItems();
    });

    this.refreshSubscription = this.caseService.refreshCaseObservable.subscribe(() => {
      this.getCase();
    });

  }

  ngOnInit() {
  }

  getCase(){

    this.showCaseHeader = false;
    this.caseCompleted = false;

    if (this.caseId) {

      //this.reloadKlyantDetails();

      this.caseService.getCase(this.caseId).subscribe(response => {
        this.case = response;
        this.caseLoaded = true;
        this.klyantService.klyantEnabled().subscribe(response => {
          this.klyantEnabled = response;
        });

        /* Work out whether we need to display the case header*/
        if(this.case.caseData.onHold)
        {
          this.showCaseHeader = true;
          this.caseHeaderMessage = 'On Hold';
          this.caseHeaderColour = "#4173f0";

        }
        else if(this.case.caseData.isCancelled)
        {
          this.showCaseHeader = true;
          this.caseHeaderMessage = 'Cancelled';
          this.caseHeaderAlert = true;
        }
        else if(this.case.caseData.isInstructed && this.case.caseData.allocatedToParalegalUser == null) // unallocated
        {
          this.showCaseHeader = true;
          this.caseHeaderMessage = 'Unallocated';
          this.caseHeaderWarning = true;
        }
        else if(!this.case.caseData.isInstructed)
        {
          this.showCaseHeader = true;
          this.caseHeaderMessage = 'Uninstructed';
          this.caseHeaderWarning = true;
        }
        else if(this.case.caseData.isCompleted)
        {
          this.caseCompleted = true;
        }
        else{
          // clear fields down otherwise the banner won't be correct when switching between cases from the recent case list
          this.showCaseHeader = false;
          this.caseHeaderMessage = '';
          this.caseHeaderAlert = false;
          this.caseHeaderWarning = false;
          this.caseHeaderInfo = false;
          this.caseHeaderColour = '';
          this.caseCompleted = false;
        }

        this.caseReference = this.case.caseData.caseReference;


      });
    }
  }

  loadKlyant() {

    // first need to check if all data has been populated before sending over to klyant
    

    this.klyantService.checkCaseDataPopulatedForKlyant(this.caseId).subscribe(response => {
      if(response){
       this.openKlyant();
      }
      else{

         const modalRef = this.modalService.openWithOptions(OkPopupComponent, {size: 'lg'});
                 
          modalRef.componentInstance.messageHeader = 'Incomplete Case Information?';
          modalRef.componentInstance.popupText1 = 'Check Property Address has been Completed';
          modalRef.componentInstance.popupText2 = '';
      }
    }); 

   
  }

  openKlyant(){


    const modalRef = this.modalService.openWithOptions(KlyantComponent, { size: 'lg'});

    modalRef.componentInstance.caseId = this.caseId;
    modalRef.componentInstance.klyantClientId = this.case.caseData.klyantClientId;
    modalRef.componentInstance.klyantMatterId = this.case.caseData.klyantMatterId;

    modalRef.result.then(
      (result) => {
        if (result === true) 
        {
          window.location.reload();
        }
      },
      () => {} // dismissed - do nothing
    );

  }

  viewInKlyant(){
    window.open(environment.klyant.guiBaseUrl + '/matters/' + this.case.caseData.klyantMatterId , '_blank');
  }

  loadCorrespondenceItems(){

    this.timelineItemsLoading = true;

    let search = {
      typeIds : this.searchType,
      searchText: this.searchString
    }

    if (this.caseId) {
      this.correspondenceTimelineService.getCorrespondenceTimelineItems(this.caseId, search).subscribe(response => {
        this.correspondenceTimelineItems = response.items;
        this.timelineItemsLoading = false;
      });
      this.correspondenceTimelineService.getArchivedCorrespondenceTimelineItems(this.caseId).subscribe(response => {
        this.archivedCorrespondenceTimelineItems = response.items;
      });
    }
  }

  getSelected() {
    if (!this.timelineItems) return null;
    return this.timelineItems.map(p => p.selected).join(', ');
  }

  atLeastOneItemSelected() {
    if (!this.timelineItems) return false;
    return this.timelineItems.some(p => p.selected == true);
  }

  atLeastTwoItemsSelected() {
    if (!this.timelineItems) return false;
    return (this.timelineItems.filter(p => p.selected == true).length >= 2);
  }


  dropActive() {

  }

  dragOver(event: any) {
    event.preventDefault();
    event.stopPropagation();
    this.showDrop = true;

    if (this.innerContent?.nativeElement) {
        this.renderer.setStyle(this.innerContent.nativeElement, 'pointer-events', 'none');
    }
  }

  dragLeave(event: any) {
    event.preventDefault();
    event.stopPropagation();

    if (!(event.currentTarget as HTMLElement).contains(event.relatedTarget as Node)) {
      this.showDrop = false;
    }
  }

  dragDrop(event: any) {
    event.preventDefault();
    event.stopPropagation();

    let files = event.dataTransfer.files;

    this.existingFiles = [];

    if (files.length > 0) {
      for (var i = 0; i < files.length; i++) {
        var fileName = files[i].name;
        for (var j = 0; j < this.correspondenceTimelineItems.length; j++) {
          if (this.correspondenceTimelineItems[j].caseFile != null && fileName == this.correspondenceTimelineItems[j].caseFile.fileName) {
            this.existingFiles.push(fileName);
          }
        }

        for (var j = 0; j < this.archivedCorrespondenceTimelineItems.length; j++) {
          if (this.archivedCorrespondenceTimelineItems[j].caseFile != null && fileName == this.archivedCorrespondenceTimelineItems[j].caseFile.fileName) {
            this.existingFiles.push(fileName);
          }
        }
      }
    }

    this.showDrop = false;

     const modalRef = this.modalService.openWithOptions(FileUploaderComponent, { size: 'lg'});

      modalRef.componentInstance.caseId = this.caseId;
      modalRef.componentInstance.files = files;
      modalRef.componentInstance.existingFiles = this.existingFiles;

       const resetPointerEvents = () => {
        if (this.innerContent?.nativeElement) {
            this.renderer.setStyle(this.innerContent.nativeElement, 'pointer-events', 'all');
        }
      };

      modalRef.result.then(
        (result) => {
          if (result === true) {
            // Files uploaded successfully
          }
           resetPointerEvents();
        },
        () => {
          // Dismissed
           resetPointerEvents();
        }
      );

  }

  optionClick(event: any) {
    event.preventDefault();
    event.stopPropagation();
  }


  dblClickItem(item: any)
  {
    this.selectedItem = item;

    switch(item.correspondenceTypeId)
    {
      case 1: //Email
      this.openEmail(item.emailItem);
        break;
      // @ts-ignore
      case 2: {
          if (item.caseFile.fileName.slice(item.caseFile.fileName.length - 5) == '.docx') {

            // letters will have a casefile associated with them and will open word for editing
            // window.open(environment.apiUrl + 'letters/edit/' + this.caseId + '/' + item.caseFile.caseFileId + '/' + item.caseFile.fileName, "_blank");
            this.lettersService.editletter(this.caseId!, item.caseFile.caseFileId, item.caseFile.fileName).subscribe(response => {
              var blob = response.body;
              if (blob != null) {
                var a = document.createElement('a');
                a.download = item.caseFile.fileName;
                a.href = URL.createObjectURL(blob); // (window.webkitURL || window.URL)
                //a.dataset.downloadurl = ['application/vnd.openxmlformats', a.download, a.href].join(':');
                a.click();
              }
            });
            break;
          }
          // falls through
        }

      case 3: //Case File

      /* Formats
        PDF = 1,
        DocX = 2,
        EML = 3,
        xlsX = 4,
        IMG = 5,
        Doc = 6,
        xls = 7
      */

        switch(item.caseFile.format)
        {
          case 1: //PDF
          case 5: //IMG
          case 6: //Doc
          case 7: //XLS
          case 2:
          case 4:
          case 8: // html files
              this.caseFilesService.getFile(item.entityId).subscribe(response => {
                var blob = response.body;
                if(blob != null) {
                  // For PDFs and images
                  const fileURL = URL.createObjectURL(blob);
                  //const fileURL = URL.createObjectURL(response.body);
                  window.open(fileURL, '_blank');
                }
              });
            break;


          case 3: // Emails
              //alert('email case files - not handled yet');
              this.caseFilesService.getFile(item.entityId).subscribe(response => {
                var blob = response.body;
                if(blob != null) {
                  var a = document.createElement('a');
                  a.download = item.caseFile.fileName;
                  a.href = URL.createObjectURL(blob);
                  a.click();
                }
              });
            break;
        }

      break;
      case 4: //Phonecall
        this.openPhone(item.phoneCall);
        break;
      case 5: //Text
        this.openSms(item.smsItem);
        break;
      case 6: //Fax
      this.openFax(item.faxItem);
        break;
      case 7: // O365 email picked up by Graph
        this.caseFilesService.getFile(item.entityId).subscribe(response => {
          var blob = response.body;
          if(blob != null) {
            var a = document.createElement('a');
            a.download = item.caseFile.fileName;
            a.href = URL.createObjectURL(blob);
            a.click();
          }
        });
        break;
       case 8: //Note
      this.openCaseNote(item.caseNote);
        break;
    }

  }


  onContextMenu(event: MouseEvent, item: any) {
    event.preventDefault();
    event.stopPropagation();
    this.contextMenuPosition.x = event.clientX + 'px';
    this.contextMenuPosition.y = event.clientY + 'px';

    this.contextMenu.closeMenu();

    if(this.atLeastTwoItemsSelected())
    {
      this.contextMenu.menuData = { 'item': null };
      this.contextMenu.menu.focusFirstItem('mouse');
      this.contextMenu.openMenu();
    }
    else{
      this.contextMenu.menuData = { 'item': item };
      this.contextMenu.menu.focusFirstItem('mouse');
      this.contextMenu.openMenu();
    }

  }

  previewDocument(item: any) {
    const modalRef = this.modalService.openWithOptions(DocumentPreviewComponent, {size: 'xl', scrollable: true});
    modalRef.componentInstance.caseFileId = item.entityId;
  }


  openPortal1Case() {
    window.location.href = environment.portal1Url + '/case/' + this.caseId;
  }

  openPDFStitcher(){

    let items: any [] = [];

    this.timelineItems.forEach(p => {
      if(p.selected == true)
      {
        items.push(p.details); // details is the correspondence item itself
      }
    });

    const modalRef = this.modalService.open(PdfCreatorComponent);
      
    modalRef.componentInstance.caseId = this.caseId;
    modalRef.componentInstance.items = items;


  }

  generatePDF(item: any){

    const modalRef = this.modalService.open(ItemPdfGeneratorComponent);
      
    modalRef.componentInstance.caseId = this.caseId;
    modalRef.componentInstance.item = item;

  }

  openRename(item: any){

     const modalRef = this.modalService.openWithOptions(RenameItemComponent, {
      size: 'lg'
    });
    
    modalRef.componentInstance.timelineItem = item;
  }

  openEmail(emailObj: any) {

    let items: any [] = [];
    emailObj.attachments.forEach((item : any) => {
        items.push(item.caseFile);
     });

    const modalRef = this.modalService.openWithOptions(EmailComponent, { windowClass: 'emailModal', scrollable: true});
    modalRef.componentInstance.caseId = this.caseId;
    modalRef.componentInstance.emailObj = emailObj;
    modalRef.componentInstance.caseFiles = items;
  }

  openPhone(phonecallObj: any) {

     const modalRef = this.modalService.openWithOptions(PhonecallComponent, {
      size: 'md'
    });
    
    modalRef.componentInstance.phonecallObj = phonecallObj;

  }

  openSms(smsObj: any) {

     const modalRef = this.modalService.openWithOptions(SmsComponent, {
      size: 'md'
    });
    
    modalRef.componentInstance.smsObj = smsObj;
  }

  openFax(faxObj: any) {

     const modalRef = this.modalService.openWithOptions(FaxComponent, {
      size: 'md'
    });

    let items: any [] = [];
    faxObj.attachments.forEach((item : any) => {
        items.push(item.caseFile);
     });
    
    modalRef.componentInstance.faxObj = faxObj;
    modalRef.componentInstance.caseFiles = items;
  }

  openCaseNote(caseNoteObj: any) {
    const modalRef = this.modalService.openWithOptions(ViewCaseNoteComponent, {
      size: 'md'
    });
    
    modalRef.componentInstance.caseNoteObj = caseNoteObj;
  }

  emailItems(item: any){

    let items: any [] = [];
    if(item !== null)
    {
      items.push(item.caseFile);
    }
    else
    {
      this.timelineItems.forEach(item => {
        if(item.selected == true && (item.details.correspondenceTypeId == 2 || item.details.correspondenceTypeId == 3))
        {
          items.push(item.details.caseFile);
        }
      });
    }

    // Only case files/ pdfs or letters can be emailed
    if(items.length == 0)
      alert('No valid files have been selected for emailing');
    else
    {
      const modalRef = this.modalService.openWithOptions(EmailComponent, { windowClass: 'emailModal', scrollable: true});
      modalRef.componentInstance.caseId = this.caseId;
      modalRef.componentInstance.caseFiles = items;
    }
  }

  faxItems(item: any){

    let items: any [] = [];

    if(item !== null)
    {
      items.push(item.caseFile);
    }
    else
    {
      this.timelineItems.forEach(item => {
        if(item.selected == true && (item.details.correspondenceTypeId == 2 || item.details.correspondenceTypeId == 3))
        {
          items.push(item.details.caseFile);
        }
      });
    }

    // Only case files can be emailed
    if(items.length == 0)
      alert('No valid files have been selected for faxing');
    else
    {
      const modalRef = this.modalService.openWithOptions(FaxComponent, {
        size: 'md'
      });
      
      modalRef.componentInstance.caseId = this.caseId;
      modalRef.componentInstance.caseFiles = items;
    }
  }


  pinItem(item: any){
    this.correspondenceTimelineService.pinItem( item.id, this.caseId).subscribe(response => {
      this.correspondenceTimelineService.refreshCaseTimeline.next();
    });
  }

  unpinItem(item: any){
    this.correspondenceTimelineService.unpinItem( item.id, this.caseId).subscribe(response => {
      this.correspondenceTimelineService.refreshCaseTimeline.next();
    });
  }

  highlightItem(item: any){
    this.correspondenceTimelineService.highlightItem( item.id, this.caseId).subscribe(response => {
      this.correspondenceTimelineService.refreshCaseTimeline.next();
    });
  }

  unhighlightItem(item: any){
    this.correspondenceTimelineService.unhighlightItem( item.id, this.caseId).subscribe(response => {
      this.correspondenceTimelineService.refreshCaseTimeline.next();
    });
  }

  archiveItems(item: any){

    let items: any [] = [];

    if(item !== null)
    {
      items.push(item.id);
    }
    else
    {
      this.timelineItems.forEach(item => {
        if(item.selected == true && (item.details.correspondenceTypeId != 9 && item.details.correspondenceTypeId != 10))
        {
          items.push(item.details.id);
        }
      });
    }

     const modalRef = this.modalService.openWithOptions(ArchiveTimelineItemComponent, {});
  
      modalRef.componentInstance.caseId = this.caseId;
      modalRef.componentInstance.itemIds = items;

      modalRef.result.then(
        (result) => {
          if (result === true) {
            this.correspondenceTimelineService.refreshCaseTimeline.next();
          }
        },
        () => {} // Dismiss callback
      );
    
  }

  searchTimeline(){
      this.loadCorrespondenceItems();
  }

  clearSearch(){
    this.searchType = [];
    this.searchString ='';
    this.loadCorrespondenceItems();
  }

  ngOnDestroy(){
    if (this.refreshSubscription) {
      this.refreshSubscription.unsubscribe();
    }

    if(this.refreshTimelineSubscription){
      this.refreshTimelineSubscription.unsubscribe();
    }
  }

  cancelMultiSelect(){
    this.allowMultiSelect = false;

    this.timelineItems.forEach(item => {
      if(item.selected == true)
      {
        item.selected = false;
      }
    });
  }

  offHoldCase(){

    const modalRef = this.modalService.openWithOptions(OffHoldComponent, {size: 'lg'});
    modalRef.componentInstance.caseId = this.caseId;

    modalRef.result.then(
      (result) => {
       if(result)
       {
            window.location.reload();
       }
    },
      () => {} // dismissed - do nothing
    );  
  }

  putCaseOnHold(){

   const modalRef = this.modalService.openWithOptions(OnHoldComponent, {size: 'lg'});
    modalRef.componentInstance.caseId = this.caseId;

    modalRef.result.then(
        (result) => {
          if(result)
          {
           this.correspondenceTimelineService.refreshCaseTimeline.next();
            this.caseService.refreshCaseOverview.next();
            window.location.reload();
      }
    },
      () => {} // dismissed - do nothing
    );
  }

  viewArchivedItems(){
    const modalRef = this.modalService.openWithOptions(ArchivedTimelineItemListComponent, {
      size: 'xl'
    });
    
    modalRef.componentInstance.caseId = this.caseId;
  }

  reloadKlyantDetails() {     
    if (this.sideBar) {
      this.sideBar.loadKlyantDetails()
    }
    this.klyantService.getKlyantDetails(this.caseId).subscribe(response => {
      this.klyantDetails = response;
    });      
  }

  toggleSearchType(value: string) {
  const index = this.searchType.indexOf(value);
  if (index > -1) {
    this.searchType.splice(index, 1);
  } else {
    this.searchType.push(value);
  }
}
}
